import type { ContactRecord } from '../types';
import { RecordAlert } from './bits';

/**
 * The record of a contact whose personal data were deleted (GDPR, api-gdpr.md „Contact record after the
 * deletion"): the server's text („Personenbezogene Daten gelöscht am 30.09.2026 (DSGVO).") above the columns.
 */
export function GdprDeletedBanner({ deleted }: { deleted: NonNullable<ContactRecord['gdprDeleted']> }) {
  return (
    <RecordAlert
      tone="info"
      title={deleted.text}
      text="Name, Kontaktdaten, Nachrichten und Dokumente sind entfernt. Deals, Beträge und Stages bleiben erhalten; die Werkzeuge der Akte sind gesperrt."
    />
  );
}
